"use strict";

exports.__esModule = true;

var _Animator = _interopRequireDefault(require("./components/Animator"));

exports.Animator = _Animator["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }